import React from 'react';
import { Tooltip } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

interface SidebarNavItemProps {
  key: string;
  icon: React.ReactNode;
  label: string;
  path: string;
  collapsed: boolean;
  isLogout?: boolean;
  onLogout?: () => void;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  icon,
  label,
  path,
  collapsed,
  isLogout,
  onLogout,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  /** Giữ tiền tố `/admin` khi user đang ở under-path deployment không dùng BrowserRouter basename. */
  function resolveNavPath(rawPath: string): string {
    if (!rawPath) return rawPath;
    if (pathname === '/admin' || pathname.startsWith('/admin/')) {
      if (rawPath === '/') return '/admin';
      if (rawPath.startsWith('/admin')) return rawPath;
      return `/admin${rawPath}`;
    }
    return rawPath;
  }

  const isActive =
    !isLogout &&
    (location.pathname === path ||
      location.pathname === resolveNavPath(path) ||
      (path === '/' &&
        (location.pathname === '/' ||
          location.pathname === '/admin' ||
          location.pathname.endsWith('/admin'))) ||
      (path !== '/' &&
        path !== '' &&
        (location.pathname.startsWith(path + '/') ||
          location.pathname.startsWith(`${resolveNavPath(path)}/`))));

  const handleClick = () => {
    if (isLogout && onLogout) {
      onLogout();
      return;
    }
    if (path) navigate(resolveNavPath(path));
  };

  const content = (
    <button
      type="button"
      onClick={handleClick}
      className={`admin-sidebar-nav-item ${isActive ? 'active' : ''}`}
    >
      <span className="anticon">{icon}</span>
      {!collapsed && <span>{label}</span>}
    </button>
  );

  if (collapsed) {
    return (
      <Tooltip title={label} placement="right">
        {content}
      </Tooltip>
    );
  }

  return content;
};
